import {PDFList} from "./PDFList";
let ReactDOM = require("react-dom");
let React = require("react");
import 'shared/styles/bootstrap.css';

ReactDOM.render(<PDFList/>,document.getElementById('app'));